<!--
 * @Descripttion: 亲子儿歌详情
 * @Author:xionggang
-->
<template>
  <div class="video-box">

    <div v-lazy:background-image="videoInfo.coverUrl" class="video-detail">

      <Back v-if="!isFromMiniprogramFn" @goBack="goBack">
        <div slot="header">
          <div class="back" @click.stop="goBack">
            <van-icon name="arrow-left" size="20"/>
          </div>
        </div>
      </Back>
      <child-video
          v-show="showVideo"
          ref="childVideo"
          :userInfo="userInfo"
          :videoDetail="videoInfo"
          :videoId="videoInfo.id"
          class="video-child"
          @isLogin="isLoginUser"
      ></child-video>
      <img alt class="play-icon" src="../../../assets/images/icon/off.png" @click="playerVideo"/>
    </div>
    <!-- 儿歌信息 -->
    <div class="intro">
      <h3>{{ videoInfo.name }}</h3>
      <p class="text">{{ videoInfo.title }}</p>
    </div>
    <template v-if="!isFromMiniprogramFn">
      <comment-field ref="focus" :title="videoInfo.title" :articalId="videoInfo.id" :carrierId="carrierId" :isGoLogin="isGoLogin">
        <template slot="audio">
          <span class="commentShare" @click.stop="onLike(videoInfo)">
            <div>
              <img
                  :src="!videoInfo.orLike?require('../../../assets/images/icon/like_.png'):require('../../../assets/images/icon/like3.png')"/>

              <span class="num">{{ fomatterNum(videoInfo.likeNum) }}</span>
            </div>
          </span>
          <!-- 收藏 -->
          <span class="commentShare share3" @click.stop="onCllect(videoInfo)">
            <div>

              <img
                  :src="!videoInfo.orFavorites?require('../../../assets/images/icon/praise_.png'):require('../../../assets/images/icon/collect3.png')"
                  alt
                  class="share2 collect-shareshare"
              />
              <span class="num">{{ fomatterNum(videoInfo.collectNum) }}</span>
            </div>
          </span>
          <!-- 分享 -->
          <span class="commentShare share2" @click.stop="shareLink(videoInfo)">
            <div>
              <img
                  alt
                  class="share1"
                  src="@/assets/images/icon/share_.png"

              />

            </div>
          </span>
        </template>
      </comment-field>
      <all-comment ref="allComment" :articalId="videoInfo.id" :carrierId="carrierId" :isGoLogin="isGoLogin"
                  :title="videoInfo.title"
                  @focusOn="getFocusOn" @type="getType"></all-comment>
      <audioShare ref="share"></audioShare>
      <!-- 登录注册弹窗 -->
      <login-tip
          :show="checkLogin"
          @cancleWay="cancleWay"
          @confirmWay="confirmWay"
      ></login-tip>
    </template>
  </div>
</template>
<script>
//工具类
import {
  Debounce,
  fomatterNum,
  getCookie,
  getHeadImgAndName,
  getUrlParamsByName,
  globalGoLogin,
  is_weixin,
  isFromMiniprogram,
  isUserLogin,
  setCookie,
  TestUserAgent
} from "@/assets/js/common.js";
//头部返回组件
import Back from "@/components/common/goBack";
//API接口
import API_ from "@/utils/axiosApi/childSongsApi.js";
//视频播放组件
import childVideo from "@/components/contents/calendar/video.vue";
// 输入框组件
import commentField from "@/components/comment/commentField.vue";
//评论组件
import allComment from "@/components/comment/allComment.vue";
//分享弹窗
import audioShare from "@/components/comment/share.vue";
import loginTip from "@/views/contents/calendar/component/logintip"; //注册提示组件

export default {
  data() {
    return {
      ABtest: "",
      fomatterNum: fomatterNum,
      //carrierId传值4为儿歌
      carrierId: "4",
      // 视频播放状态
      showVideo: false,
      //用户信息
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      //当前视频详情
      videoInfo: {},
      checkLogin: false,
      state: false,
    };
  },
  components: {
    childVideo,
    commentField,
    allComment,
    Back,
    audioShare,
    loginTip,
  },
  destroyed() {

  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(to, from)
      vm.initPage()
      // 不是来源于注册页的，再往session中设置值
      if (!getUrlParamsByName('fromLogin')) {
        sessionStorage.setItem("pre", from.path)
      }
      // if (vm.is_weixin()) {
      //   if (vm.getCookie("xmh_openid") == null || vm.getCookie("xmh_openid") == "") {//判断有没有openId
      //     location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
      //   } else {
      //     vm.userInfo = JSON.parse(localStorage.getItem('userInfo'));
      //     if (vm.userInfo == null || vm.userInfo == "" || vm.userInfo.mobile == null || vm.userInfo.mobile == "" || vm.userInfo.mobile == "null") {//没有手机号未注册
      //       vm.wxJsSet.getUserInfoBywx(vm, function () {
      //         vm.userInfo = JSON.parse(localStorage.getItem('userInfo'));
      //         if (vm.userInfo.mobile == null || vm.userInfo.mobile == "" || vm.userInfo.mobile == "null") {//没有手机号未注册
      //           vm.isLogin();
      //         } else {
      //           vm.initPage()
      //         }
      //       }, function () {
      //         vm.isLogin();
      //       });
      //     } else {
      //       vm.initPage()
      //     }
      //   }
      // } else {
      //   vm.userInfo = JSON.parse(localStorage.getItem('userInfo'));
      //   if (vm.getCookie("xmh_phone") == null || vm.getCookie("xmh_phone") == "" || vm.userInfo == null || vm.userInfo == "") {//未登录
      //     vm.isLogin();
      //   } else {
      //     vm.initPage()
      //   }
      // }
    })
  },
  mounted() {
  },
  methods: {
    isUserLogin, getCookie, setCookie, is_weixin,
    initPage() {
      sessionStorage.removeItem('currentPlayStatus')
      // 初始化
      this.getVideoDetail(this.$route.query.id);
      this.getUserName()
    },
    isLoginUser(state) {
      this.state = state
      if (this.isUserLogin()) {
        this.checkLogin = true;
        this.$refs.childVideo.switchVideoa()
        this.$nextTick(() => {
          this.$refs.childVideo.Player.pause();
          this.$refs.childVideo.Player.currentTime = 9;
        })
      }
    },
    // 确认
    confirmWay() {
      this.checkLogin = false;
      // this.$router.push({ path: "/phoneLogin?redirect=" + window.location.href })
      this.loginRegistSensors("确定");
    },
    // 取消
    cancleWay() {
      this.$refs.childVideo.Player.pause();
      this.$refs.childVideo.Player.currentTime = 9;
      this.checkLogin = false;
      this.loginRegistSensors("取消");
    },
    loginRegistSensors(msg) {
      sensors.track("Login_registration_pop_up", {
        operation: msg,
        page_name: "亲子儿歌",
      });
    },
    getFocusOn(bool) {
      this.$refs.focus.isFocus = bool
    },
    getType(type) {
      this.$refs.focus.type = type
    },
    // 返回上一页
    goBack() {
      if (sessionStorage.getItem('pre')) {
        if (sessionStorage.getItem('pre') == '/home' || sessionStorage.getItem('pre') == '/mine/collection') {
          this.$router.go(-1)
        } else {
          if(sessionStorage.getItem('pre') == '/search/home' || sessionStorage.getItem('pre') == '/replyComment' || sessionStorage.getItem('pre') == '/babyFeeding') {
           this.$router.go(-1)
          } else {
            this.$router.replace(sessionStorage.getItem('pre'))
          }
        }
      } else {
        this.$router.go(-1)
      }
    },
    //获取详情
    getVideoDetail(id) {
      API_.getVideoDetail(
          {},
          {id: id, crmId: this.userInfo ? this.userInfo.crm_id : ""},
          (res) => {
            if (res.code === 200) {
              const {isAndroid} = TestUserAgent()
              this.videoInfo = res.data;
              var shareDataParams = {
                shareLink: window.location.href,
                shareDesc: res.data.title,
                shareTitle: res.data.name,
                imgUrl: res.data.coverUrl, //必须是绝对路径
                shareid: res.data.id,
                shareFlag: true,
                shareType: 'songs'
              }
              this.wxJsSet.wxShare("fx", shareDataParams, this);
              if (isAndroid) {
                this.$nextTick(() => {
                  this.playerVideo();
                });
              }
            }
            // 埋点
            sensors.track("ContentView", {
              content_id: res.data.id,
              content_title: res.data.name,
              author: ''
            });

          }
      );
    },
    //播放视频
    playerVideo() {
      this.showVideo = true;
      this.$refs.childVideo.initPlayer();
    },
    // 点赞
    onLike: Debounce(function (item) {

      if (item.orLike) {
        this.cancelLike(item);
      } else {
        if (this.isUserLogin()) {
          globalGoLogin();

        } else {
          API_.addLike(
              {crmId: this.userInfo.crm_id, id: item.id},
              {},
              (res) => {
                if (res.code == 200) {
                  this.videoInfo.orLike = true;
                  this.videoInfo.likeNum++;
                  this.$toast({
                    duration: 3000,
                    message: "点赞成功",
                    context: this,
                  });
                  sensors.track("Support", {
                    content_id: item.id,
                    content_title: item.name,
                    Column: "亲子儿歌",
                    Poster_Date: "",
                    //   A_B_flow: this.ABtest,
                  });
                } else {
                  this.$toast("网络异常");
                }
              }
          );
        }
      }
    }, 100),
    //收藏
    onCllect: Debounce(function (item) {
      if (item.orFavorites) {
        this.cancelCllect(item);
      } else {
        if (this.isUserLogin()) {
          globalGoLogin();
        } else {
          API_.addCollect(
              {crmId: this.userInfo.crm_id, id: item.id},
              {},
              (res) => {
                if (res.code == 200) {
                  this.videoInfo.collectNum++;
                  this.videoInfo.orFavorites = true;
                  this.$toast({
                    duration: 3000,
                    message: "收藏成功",
                    context: this,
                  });
                } else {
                  this.$toast("网络异常");
                }
              }
          );
          sensors.track("Save", {
            content_id: item.id,
            content_title: item.name,
            Column: "亲子儿歌",
            Poster_Date: "",
            // A_B_flow: this.ABtest,
          });
        }
      }
    }, 100),
    //分享
    shareLink: Debounce(function (item) {
      this.$refs.share.showShareVideo();
      if ($('video').length > 0) {
        this.$refs.childVideo.Player.pause();
        $('#child').css("background-image", "url(" + this.videoInfo.coverUrl + ")");
        $('video').css('display', 'none');
        $('.xgplayer-controls').css('opacity', '0');
      }
      API_.addShare({id: item.id}, {}, (res) => {
        if (res.code == 200) {
          setTimeout(() => {
            if (this.videoInfo.orShare) {
              this.videoInfo.share++;
            }
            this.videoInfo.orShare = true;
            sensors.track("Share", {
              content_id: item.id,
              content_title: item.name,
              Column: "亲子儿歌",
              Poster_Date: "",
              //   A_B_flow: "",
            });
          }, 500);
        } else {
          this.$toast("网络异常");
        }
      });
    }, 100),
    //取消点赞
    cancelLike: Debounce(function (item) {
      if (this.isUserLogin()) {
        globalGoLogin();
      } else {
        API_.cancelLike(
            {crmId: this.userInfo.crm_id, id: item.id},
            {},
            (res) => {
              if (res.code == 200) {
                this.videoInfo.orLike = false;
                this.videoInfo.likeNum--;
                sensors.track("Unsupport", {
                  content_id: item.id,
                  content_title: item.name,
                  Column: "亲子儿歌",
                  Poster_Date: "",
                  // A_B_flow: this.ABtest,
                });
              } else {
                this.$toast("网络异常");
              }
            }
        );
      }
    }, 100),
    // 取消收藏
    cancelCllect: Debounce(function (item) {
      if (this.isUserLogin()) {
        globalGoLogin();


      } else {
        API_.cancelCollect(
            {crmId: this.userInfo.crm_id, id: item.id},
            {},
            (res) => {
              if (res.code == 200) {
                this.videoInfo.collectNum--;
                this.videoInfo.orFavorites = false;
                sensors.track("CancelSave", {
                  content_id: item.id,
                  content_title: item.name,
                  Column: "亲子儿歌",
                  Poster_Date: "",
                  // A_B_flow: this.ABtest,
                });
              } else {
                this.$toast("网络异常");
              }
            }
        );
      }
    }, 100),
    getUserName: async function () {
      try {
        const {headImgurl, nickName} = await getHeadImgAndName()
        this.setCookie("xmh_headimgurl", headImgurl, 365);
        this.setCookie("xmh_nickname", nickName, 365);
      } catch (err) {

      }
    },
    // getUserName: function () {
    //   if (
    //     !this.getCookie("xmh_nickname") ||
    //     this.getCookie("xmh_nickname") == "" ||
    //     !this.getCookie("xmh_headimgurl") ||
    //     this.getCookie("xmh_headimgurl") == ""
    //   ) {
    //     this.$http.get(
    //       "/wechat/getUserInfoByOpenId",
    //       { openId: getCookie("xmh_openid") },
    //       res => {
    //         if (res.code === "200") {
    //           this.setCookie('xmh_headimgurl', res.data.headimgurl, 365)
    //           this.setCookie('xmh_nickname', res.data.nickname, 365)
    //         }
    //       }
    //     );
    //   }
    // },
  },
  computed: {
    isGoLogin() {
      return this.isUserLogin();
    },
    isFromMiniprogramFn() {
      return isFromMiniprogram(this.$route);
    },
  },
};
</script>
<style lang="less" scoped>
html,
body {
  .video-box {
    background: #fff;
    min-height: 100vh;
    height: auto;

    .childVideo {
      height: 100%;
    }

    .commentShare {
      img {
        width: 14px !important;
        height: 14px !important;
      }
    }

    .video-detail {
      position: relative;
      width: 100%;
      height: 222px;

      //    rgba(0, 0, 0, 0.3)
      // background: url(https://image-mom.feihe.com/upload/2021/01/2a09563f-c739-456d-b2eb-8622fb2f4c88.jpg)
      //   no-repeat;
      background-size: 100% 100% !important;
      //   background-blend-mode: multiply;
      .play-icon {
        width: 48px;
        height: 48px;
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 2;
        transform: translate(-50%, -50%);
      }

      .back {
        position: absolute;
        left: 0;
        top: 10px;
        z-index: 99;
      }

      .info {
        color: #fff;

        .player-num {
          position: absolute;
          bottom: 10px;
          left: 10px;
        }

        .player-time {
          position: absolute;
          bottom: 10px;
          right: 10px;
        }
      }
    }

    .video-detail::after {
      position: absolute;
      top: 0;
      left: 0;
      content: "";
      background-color: rgba(0, 0, 0, 0.3);

      z-index: 1;
      width: 100%;
      height: 100%;
    }

    .intro {
      padding: 0 12px;
      min-height: 70px;
      height: auto;
      margin-bottom: 10px;

      h3 {
        font-size: 16px;
        line-height: 16px;
        padding: 15px 0 10px 0;
      }

      .text {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
}
</style>
